import { render, staticRenderFns } from "./40x.vue?vue&type=template&id=34da85fa&scoped=true"
import script from "./40x.vue?vue&type=script&lang=js"
export * from "./40x.vue?vue&type=script&lang=js"
import style0 from "./40x.vue?vue&type=style&index=0&id=34da85fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34da85fa",
  null
  
)

export default component.exports